export default {
  // 新增客户租金
  insertYgnCustRent: '/ygsjzs/ygnCustRent/insertYgnCustRent',
  // 修改客户租金
  updateYgnCustRent: '/ygsjzs/ygnCustRent/updateYgnCustRent',
  // 物理删除客户租金
  deleteDataYgnCustRent: '/ygsjzs/ygnCustRent/deleteDataYgnCustRent',
  // 查询客户租金详情
  selectYgnCustRentByStorageId: '/ygsjzs/ygnCustRent/selectYgnCustRentByStorageId',
  // 分页查询客户租金列表
  selectYgnCustRentByPage: '/ygsjzs/ygnCustRent/selectYgnCustRentByPage'
}
